import { ProjectAction, ProjectRole } from './types';

const PERMISSIONS: Record<ProjectAction, ReadonlySet<ProjectRole>> = {
  'work-item.write': new Set<ProjectRole>([
    'Owner',
    'Maintainer',
    'Collaborator',
  ]),
  // Approve, force-approve, un-approve and delete requirements.
  'work-item.approve': new Set<ProjectRole>(['Owner', 'Maintainer']),
  'project.artifacts.manage': new Set<ProjectRole>(['Owner', 'Maintainer']),
  'project.settings': new Set<ProjectRole>(['Owner', 'Maintainer']),
  'project.invite': new Set<ProjectRole>(['Owner', 'Maintainer']),
  'project.delete': new Set<ProjectRole>(['Owner']),
  'project.ownership-transfer': new Set<ProjectRole>(['Owner']),
};

export function canPerform(
  role: ProjectRole | null | undefined,
  action: ProjectAction,
): boolean {
  if (!role) return false;
  switch (action) {
    case 'work-item.write':
      return PERMISSIONS['work-item.write'].has(role);
    case 'work-item.approve':
      return PERMISSIONS['work-item.approve'].has(role);
    case 'project.artifacts.manage':
      return PERMISSIONS['project.artifacts.manage'].has(role);
    case 'project.settings':
      return PERMISSIONS['project.settings'].has(role);
    case 'project.invite':
      return PERMISSIONS['project.invite'].has(role);
    case 'project.delete':
      return PERMISSIONS['project.delete'].has(role);
    case 'project.ownership-transfer':
      return PERMISSIONS['project.ownership-transfer'].has(role);
    default:
      return false;
  }
}

export function roleAllowsAny(
  role: ProjectRole | null | undefined,
  allowed: ReadonlyArray<ProjectRole>,
): boolean {
  if (!role) return false;
  return allowed.includes(role);
}
